const foodsObj = [
    {
        name: 'Pelmeshki',
        price: 5000,
        status: 'available',
        desc: 'rjsdjfkldsngfls fdsngkldfjg erksngkn',
        image: 'https://cdn.fishki.net/upload/post/201510/14/1697566/53b119c3727d1dc2935f04e110a88a32.jpg'
    },
    {
        name: 'Spagetti',
        price: 500,
        status: 'available',
        desc: 'rjsdjfkfdfldsngfls fdsngkldfjg erksngkn',
        image: 'https://fb.ru/misc/i/gallery/42494/2379272.jpg'
    },
    {
        name: 'Samsa',
        price: 192,
        status: 'available',
        desc: 'rjsdfrtjtrv    fkld   sntfltrs t erksngkn',
        image: 'https://avatars.mds.yandex.net/get-zen_doc/1907561/pub_5db6abe8b477bf00ac531ff6_5db6b05b1febd400af66aa09/scale_1200'
    },
    {
        name: 'Hleb',
        price: 50,
        status: 'available',
        desc: 'fdsngkldfjg erksngkn',
        image: 'https://ural-meridian.ru/wp-content/uploads/2018/09/Hleb1.jpeg'
    },
    {
        name: 'Sol',
        price: 20,
        status: 'available',
        desc: 'rjsdjf erksngkn',
        image: 'https://www.theglobeandmail.com/resizer/fvzR9UYdfc6QM6SIfyncsuIeCbc=/1200x0/filters:quality(80)/arc-anglerfish-tgam-prod-tgam.s3.amazonaws.com/public/VKEBQG4HVFBR7M5FMKXMAR5LB4'
    },
    {
        name: 'Sup',
        price: 399,
        status: 'available',
        desc: 'awesome sup er ksngkn',
        image: 'http://www.blog.sagmart.com/wp-content/uploads/2015/07/soups-1024x683.jpg'
    },
]

export default foodsObj